import {
  AbarbeitungStatusType,
  SchrittPayloadArchivierungInitial,
  VorgangProzessSchrittStatus,
} from '@core/domain';

export function kannArchivierungFortsetzen({
  status,
  schrittStatus,
  aktuelleAbarbeitung,
  initialPayload,
}: {
  status?: string;
  schrittStatus?: string;
  aktuelleAbarbeitung: boolean;
  initialPayload: unknown;
}): boolean {
  if (
    !aktuelleAbarbeitung ||
    (status !== AbarbeitungStatusType.FEHLER &&
      status !== AbarbeitungStatusType.ZURUECKGESTELLT) ||
    schrittStatus !== VorgangProzessSchrittStatus.FEHLER
  )
    return false;
  const payload = SchrittPayloadArchivierungInitial.safeParse(initialPayload);
  return payload.success && payload.data.archivierungsFortschritt !== undefined;
}
